import { ArrowRight, Camera } from 'lucide-react';
import { Link } from 'react-router-dom';

export function AvatarBanner() {
  return (
    <section className="relative overflow-hidden bg-[#f4f7fb] py-16 sm:py-20 text-[#06194d] border-t border-b border-[#e2eaf5]">
      {/* Subtle light ambient glow */}
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#123ee0]/5 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 -bottom-24 h-72 w-72 rounded-full bg-[#16a53a]/5 blur-3xl" />

      <div className="shell relative z-10 px-4">
        <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
          <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-[#06194d] leading-[1.05]">
            Personalize sua foto com o{' '}
            <span className="text-[#16a53a]">Traiano</span>
          </h2>

          <p className="mt-4 max-w-2xl text-base sm:text-lg text-[#53617b] leading-relaxed font-body">
            Mostre seu apoio nas redes sociais! Gere fotos de perfil exclusivas e cards para stories
            e feed com os modelos oficiais do Traiano. É rápido, gratuito e tudo é gerado direto no seu
            aparelho sem enviar fotos para a internet.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3.5">
            <Link
              to="/avatar"
              className="inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-2xl bg-[#06194d] px-8 font-display text-base font-bold uppercase tracking-wider shadow-lg shadow-[#06194d]/15 hover:bg-[#0b397f] active:scale-98 transition-all cursor-pointer !text-white"
              style={{ color: '#ffffff' }}
            >
              <Camera className="h-5 w-5 text-[#16a53a]" style={{ color: '#16a53a' }} />
              <span className="font-bold text-white" style={{ color: '#ffffff' }}>
                Criar meu avatar agora
              </span>
              <ArrowRight className="h-4 w-4 text-white" style={{ color: '#ffffff' }} />
            </Link>

            <Link
              to="/avatar#figurinhas"
              className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-2xl border-2 border-[#06194d]/20 bg-white px-6 font-display text-base font-bold uppercase tracking-wider shadow-xs hover:bg-[#eef4fc] hover:border-[#06194d]/40 active:scale-98 transition-all cursor-pointer"
              style={{ color: '#06194d' }}
            >
              <span className="font-bold" style={{ color: '#06194d' }}>
                Ver figurinhas de WhatsApp
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
